import { Component } from '@angular/core';
import { TranslationPipe } from '../../pipes';

@Component({
  selector: 'app-detour',
  standalone: true,
  imports: [TranslationPipe],
  styleUrl: './detour.component.scss',
  templateUrl: './detour.component.html'
})
export class DetourComponent {
}
